import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../i18n";

export default function NewsletterForm({ variant = "light" }) {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const dark = variant === "dark";

  const onSubmit = (e) => {
    e.preventDefault();
    try {
      if (typeof window !== "undefined") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "newsletter_submit",
          name_provided: !!name,
          email_domain: email.includes("@") ? email.split("@")[1] : undefined,
        });
      }
    } catch (_) {}
    navigate("/thank_you");
  };

  return (
    <form
      onSubmit={onSubmit}
      data-testid="newsletter-form"
      noValidate
      className={`w-full ${
        dark ? "text-white" : "text-[#101828]"
      } flex flex-col gap-4`}
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label
            htmlFor="nl-name"
            className={`block text-xs uppercase tracking-widest font-bold mb-2 ${
              dark ? "text-white/70" : "text-[#475467]"
            }`}
          >
            {t("newsletter.nameLabel")}
          </label>
          <input
            id="nl-name"
            data-testid="newsletter-name-input"
            required
            minLength={2}
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={t("newsletter.namePlaceholder")}
            className={`w-full h-12 px-4 border ${
              dark
                ? "bg-transparent border-white/30 text-white placeholder-white/40 focus:border-white"
                : "bg-white border-gray-300 text-[#101828] placeholder-gray-400 focus:border-[#1E3A8A]"
            } focus:outline-none focus:ring-2 focus:ring-[#1E3A8A]/40`}
            autoComplete="name"
          />
        </div>
        <div>
          <label
            htmlFor="nl-email"
            className={`block text-xs uppercase tracking-widest font-bold mb-2 ${
              dark ? "text-white/70" : "text-[#475467]"
            }`}
          >
            {t("newsletter.emailLabel")}
          </label>
          <input
            id="nl-email"
            type="email"
            data-testid="newsletter-email-input"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("newsletter.emailPlaceholder")}
            className={`w-full h-12 px-4 border ${
              dark
                ? "bg-transparent border-white/30 text-white placeholder-white/40 focus:border-white"
                : "bg-white border-gray-300 text-[#101828] placeholder-gray-400 focus:border-[#1E3A8A]"
            } focus:outline-none focus:ring-2 focus:ring-[#1E3A8A]/40`}
            autoComplete="email"
          />
        </div>
      </div>
      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        <button
          type="submit"
          data-testid="newsletter-submit-btn"
          className={`h-12 px-6 text-sm font-semibold tracking-wide ${
            dark
              ? "bg-white text-[#0C111D] hover:bg-gray-200"
              : "bg-[#1E3A8A] text-white hover:bg-[#1E40AF]"
          }`}
        >
          {t("newsletter.submit")}
        </button>
        <p
          className={`text-xs leading-relaxed ${
            dark ? "text-white/60" : "text-[#475467]"
          } max-w-md`}
        >
          {t("newsletter.consent")}
        </p>
      </div>
    </form>
  );
}
